import Http from '@/api/request'

/**
 * 我的喜欢相关接口
 */
export const LikesApi = {
  // 版权详情
  apiGetLikeList(params) {
    return Http.get(`/v2/favors`, params)
  },
  // 加入喜欢
  apiJoinLike(params) {
    return Http.post(`/v2/favor/${params.id}`, params)
  },
  // 取消喜欢
  apiDeleteLike(params) {
    return Http.post(`/v2/batchdelfavor?worksIds=${params.worksIds}`, params)
  },
  // 全局底部公共播放器 - 我喜欢的音乐列表
  getLikeMusicList(params) {
    return Http.get(`/v2/favor_music_list`, params)
  }
}
